import React, { memo, useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { LoadingButton } from "@mui/lab";
import {
  Autocomplete,
  Box,
  Grid,
  IconButton,
  InputAdornment,
  Modal,
  Snackbar,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import moment from "moment";
import { Fileuploadrequestcall } from "../../request/Fileuploadrequest";
import { Postrequestcall } from "../../request/Postrequest";
import { BILightGrey } from "../../assets/helpers";
import {
  FETCH_CLIENT_EMPLOYEE_V2,
  FETCH_CLIENTS_EMPLOYEES_V2,
  SAVE_CLIENT_SAR_ACTIONS,
  SAVE_CLIENT_SAR_ACTIONS_PICTURES
} from "../../constant/Apipath";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";
import InfiniteEmployeeScroll from "./InfiniteEmployeeScroll";
import dayjs from "dayjs";

export default function ClientSARActionsAddModel({
  isOpen,
  onClose,
  SARid,
  from,
  mode,
  reloadData
}) {
  const imgRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("");

  const [deleteImageList, setDeleteImageList] = useState([]);
  const [uploadedImageList, setUploadedImageList] = useState([]);
  const [clientEmployeData, setClientEmployeData] = useState([]);
  const [dueDate, setDueDate] = useState(null);
  const [description, setDescription] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const userId = loginData?.userInformation?.UserId;
  const [empData, setEmpData] = useState({
    id: 0,
    label: ""
  });
  const [open, setOpen] = useState(false);

  //for multi language
  const LANGUAGE = ClientEnglishFallback.ClientSARActionsAddModel(
    multiLanguageData?.ClientSARActionsAddModel || {}
  );
  const {
    TEXT_EMPLOYEE,
    TEXT_SEARCH_EMPLOYEE,
    TEXT_TITLE,
    TEXT_ENTER_TITLE,
    TEXT_DESCRIPTION,
    TEXT_DESCRIPTION_PLACEHOLDER,
    TEXT_DUE,
    TEXT_CHOOSE_DATE,
    TEXT_SAVE
  } = LANGUAGE;

  const CLIENT_ACCENT_COLOR = selectedClientData?.AccentColor;
  const TOKEN = loginData?.accessToken;

  const handleAddImage = () => {
    imgRef.current.click();
  };

  const [employeePage, setEmployeePage] = useState(1);
  const [hasMoreEmployees, setHasMoreEmployees] = useState(true);
  const [employeeLoading, setEmployeeLoading] = useState(false);

  const getClientEmployeeData = async (page = 1, append = false) => {
    try {
      setEmployeeLoading(true);
      let obj = {
        PageNr: page,
        NrOfRecPerPage: 20,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            ClientId: selectedClientData?.ClientId
          }
        ]
      };
      const clientEmployeeResponse = await Postrequestcall(
        // FETCH_CLIENT_EMPLOYEE_V2,
        FETCH_CLIENTS_EMPLOYEES_V2,
        obj,
        loginData?.accessToken
      );
      if (clientEmployeeResponse.status === 200) {
        const datas = clientEmployeeResponse?.data?.data;
        let temp = [];
        datas?.forEach((data) => {
          if (data?.id !== selectedClientData?.ClientEmployeeId) {
            temp.push({
              id: data.id,
              label: data.firstName + " " + data.lastName
            });
          }
        });
        if (append) {
          setClientEmployeData((prev) => [...prev, ...temp]);
        } else {
          setClientEmployeData(temp);
        }
        setHasMoreEmployees(temp.length === 20);
        setEmployeePage(page);
      } else {
        setHasMoreEmployees(false);
        console.log("getClientEmployeeData-> Error Fetching Client Employee");
      }
    } catch (error) {
      setHasMoreEmployees(false);
      console.log("getClientEmployeeData-> Error Fetching Client Employee: ", error);
    } finally {
      setEmployeeLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) getClientEmployeeData(1, false);
  }, [isOpen]); // eslint-disable-next-line react-hooks/exhaustive-deps

  const fetchMoreEmployees = () => {
    if (!employeeLoading && hasMoreEmployees) {
      getClientEmployeeData(employeePage + 1, true);
    }
  };

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");

  const handelSubmit = async () => {
    setLoading(true);
    try {
      const payload = {
        ReturnRecordId: true,
        ReturnRecordError: true,
        UserId: userId,
        SaveList: [
          {
            Id: 0,
            SARId: SARid,
            EmployeeId: empData?.id,
            Title: title,
            Description: description,
            DueDate: moment(dueDate).format("YYYY-MM-DD"),
            ModifiedBy: userId
          }
        ]
      };

      const res = await Postrequestcall(SAVE_CLIENT_SAR_ACTIONS, payload, TOKEN);

      if (res.status === 201) {
        if (uploadedImageList?.length > 0) {
          let promise = uploadedImageList?.map((picture) => {
            const formData = new FormData();
            formData.append("Id", picture.id ?? 0);
            formData.append("SARActionId", res?.data?.data[0]?.objData?.id);
            formData.append("ModifiedBy", userId);
            formData.append("FileName", picture);
            return Fileuploadrequestcall(SAVE_CLIENT_SAR_ACTIONS_PICTURES, formData, TOKEN);
          });
          await Promise.all(promise);
        }
      }
    } catch (err) {
      setSnackbarMsg(`An error occurred: ${err.message || "Unable to save data"}`);
      setSnackbarOpen(true);
      alert(`An error occurred: ${err.message || "Unable to save data"}`);
      console.error("handelSubmit-> Error Saving Client SAR Actions: ", err);
    } finally {
      resetData();
      reloadData();
      setLoading(false);
      onClose();
    }
  };

  // const handleImageChange = (event) => {
  //   let temp = [...uploadedImageList];
  //   let files = event.target.files;
  //   for (let i = 0; i < files?.length; i++) {
  //     temp.push(files[i]);
  //   }
  //   setUploadedImageList(temp);
  //   event.target.value = "";
  // };
  const handleImageChange = (event) => {
    let temp = [...uploadedImageList];
    let files = event.target.files;
    for (let i = 0; i < files?.length; i++) {
      const file = files[i];
      if (file.type && file.type.startsWith("image/")) {
        temp.push(file);
      } else {
        setSnackbarMsg("Only image files are allowed.");
        setSnackbarOpen(true);
      }
    }
    setUploadedImageList(temp);
    event.target.value = "";
  };
  const handleInputChange = (value, field) => {
    setEmpData({ ...value });
    setSearchTerm(value.label || "");
  };

  // Prevent duplicate employee selection
  useEffect(() => {
    if (!isOpen) {
      setEmpData({ id: 0, label: "" });
      setSearchTerm("");
    }
  }, [isOpen]);

  const handleRemoveImage = useCallback(
    (picture, index) => {
      const deleteList = [...deleteImageList];
      if (picture.id) {
        deleteList.push({ id: picture?.id });
      }
      setDeleteImageList(deleteList);
      let temp = [...uploadedImageList];
      temp.splice(index, 1);
      setUploadedImageList(temp);
    },
    [uploadedImageList, deleteImageList]
  );

  const resetData = () => {
    setUploadedImageList([]);
    setDescription("");
    setDueDate(null);
    setTitle("");
    // reloadData();
  };

  return (
    <>
      <Snackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMsg || "Only image files are allowed."}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      />
      <Modal
        open={isOpen}
        onClose={() => {
          resetData();
          onClose();
        }}>
        <div className="client-modal-responsive">
          <div className="action-button-container">
            <IconButton
              onClick={() => {
                resetData();
                onClose();
              }}
              sx={{
                color:
                  selectedClientData?.AccentColor !== undefined && selectedClientData?.AccentColor
                    ? selectedClientData?.AccentColor
                    : BILightGrey
              }}>
              <CloseIcon />
            </IconButton>
          </div>
          <Stack
            sx={{ padding: {
              xs: 0,
              sm: 0,
              md: 0.5,
              lg: 0.5,
              xl: 1
             }}}>
            <Grid container sx={{ display: "flex", flexDirection: "column" }}>
              <Grid>
                <Typography variant="subtitle1">{TEXT_EMPLOYEE}</Typography>
                <div id="employee-autocomplete-list" style={{ maxHeight: 200, overflow: "auto" }}>
                  <InfiniteEmployeeScroll
                    dataLength={clientEmployeData.length}
                    next={fetchMoreEmployees}
                    hasMore={hasMoreEmployees}
                    loader={employeeLoading ? <div style={{ textAlign: "center", padding: 8 }}>Loading...</div> : null}>
                    <Autocomplete
                      options={clientEmployeData.filter((emp) => emp.id !== empData.id)}
                      sx={{
                        backgroundColor: "#e4e4e4",
                        borderRadius: "10px",
                        "& fieldset": { border: "none" }
                      }}
                      size="small"
                      disablePortal
                      autoHighlight
                      getOptionLabel={(option) => option.label || ""}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      value={empData?.id ? empData : null}
                      inputValue={searchTerm}
                      onInputChange={(_, value, reason) => {
                        if (reason === "input") {
                          let inputValue = value.replace(/^[^A-Za-z0-9]+/, "");
                          setSearchTerm(inputValue);
                        }
                      }}
                      onChange={(_, selectedEmployee) => {
                        if (selectedEmployee) {
                          handleInputChange(selectedEmployee, "employee");
                        } else {
                          setEmpData({ id: 0, label: "" });
                          setSearchTerm("");
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder={TEXT_SEARCH_EMPLOYEE}
                          variant="outlined"
                          required
                          fullWidth
                        />
                      )}
                    />
                  </InfiniteEmployeeScroll>
                </div>
              </Grid>
              <Grid size={12}>
                <Typography variant="subtitle1">{TEXT_TITLE}</Typography>
                <TextField
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "0"
                    },
                    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                      border: "none"
                    }
                  }}
                  size="small"
                  style={{
                    backgroundColor: "#e4e4e4",
                    borderRadius: "10px"
                  }}
                  placeholder={TEXT_ENTER_TITLE}
                  value={title}
                  onChange={(e) => {
                    let inputValue = e.target.value;
                    inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                    setTitle(inputValue);
                  }}
                />
              </Grid>
              <Grid size={12}>
                <Typography variant="subtitle1">{TEXT_DESCRIPTION}</Typography>
                <TextField
                  slotProps={{
                    input: {
                      rows: 4,
                      multiline: true,
                      inputComponent: "textarea"
                    }
                  }}
                  rows={4}
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "0"
                    },
                    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                      border: "none"
                    }
                  }}
                  size="small"
                  style={{
                    backgroundColor: "#e4e4e4",
                    borderRadius: "10px"
                  }}
                  placeholder={TEXT_DESCRIPTION_PLACEHOLDER}
                  value={description}
                  onChange={(e) => {
                    let inputValue = e.target.value;
                    inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                    setDescription(inputValue);
                  }}
                />
              </Grid>
              <Grid>
                <Typography variant="subtitle1">{TEXT_DUE}</Typography>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Box
                    onClick={() => setOpen(true)}
                    sx={{
                      height: "40px",
                      backgroundColor: "#e4e4e4",
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "0 10px",
                      cursor: "pointer"
                    }}>
                    <span>
                      {dueDate && dayjs.isDayjs(dueDate)
                        ? dayjs(dueDate).isSame(dayjs(), "day")
                          ? `${dayjs(dueDate).format("MMM DD, YYYY")} (Today)`
                          : dayjs(dueDate).format("MMM DD, YYYY")
                        : dayjs().format("MMM DD, YYYY")}
                    </span>
                    <InsertInvitationIcon
                      sx={{
                        color: selectedClientData?.AccentColor,
                        cursor: "pointer"
                      }}
                    />
                  </Box>
                  <MobileDatePicker
                    open={open}
                    onOpen={() => setOpen(true)}
                    onClose={() => setOpen(false)}
                    format="MMM DD, YYYY"
                    value={dueDate}
                    onChange={(newValue) => {
                      setDueDate(newValue);
                    }}
                    defaultValue={dayjs()}
                    sx={{ display: "none" }} // Hide the actual picker input
                  />
                </LocalizationProvider>
              </Grid>
              <Grid sx={{ gap: 2,  marginTop: 2,  display: "flex"  }} size={12}  >
                <div
                  onClick={handleAddImage}
                  style={{
                    cursor: "pointer",
                    height: "100px",
                    minWidth: "100px",
                    border: "2px solid #e4e4e4",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                  <AddIcon />
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    maxWidth: "100%",
                    height: "100%",
                    scrollbarWidth: "none",
                    overflow: "scroll"
                  }}>
                  {uploadedImageList?.length > 0 && (
                    <ImageMemoComponent
                      selectedClientData={selectedClientData}
                      uploadedImageList={uploadedImageList}
                      handleRemoveImage={handleRemoveImage}
                    />
                  )}
                </div>
              </Grid>
            </Grid>

            <Grid>
              <LoadingButton
                onClick={handelSubmit}
                fullWidth
                disabled={!dueDate || !title || !empData?.id}
                style={{
                  marginTop: "10px",
                  background:
                    !dueDate || !title || !empData?.id ? BILightGrey : CLIENT_ACCENT_COLOR,
                  color: "white",
                  borderRadius: "10px",
                  textTransform: "none"
                }}
                loadingPosition="start"
                loading={loading}
                startIcon={<></>}>
                {TEXT_SAVE}
              </LoadingButton>
            </Grid>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              ref={imgRef}
              style={{ display: "none" }}
              multiple
            />
          </Stack>
        </div>
      </Modal>
    </>
  );
}

const ImageList = ({ uploadedImageList, handleRemoveImage, selectedClientData }) => {
  const ImgUrl = (file) => {
    try {
      let url = URL.createObjectURL(file);
      return url;
    } catch (error) {
      return file;
    }
  };
  return uploadedImageList?.map((picture, index) => (
    <div style={{ position: "relative", height: "100px" }} key={index}>
      <img
        src={picture?.fileUrl || ImgUrl(picture)}
        alt={"NO data"}
        style={{
          width: "100px",
          height: "100px",
          borderRadius: "10px"
        }}
        loading="lazy"
      />
      <IconButton
        onClick={() => handleRemoveImage(picture, index)}
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          padding: "5px",
          color:
            selectedClientData?.AccentColor !== undefined && selectedClientData?.AccentColor
              ? selectedClientData?.AccentColor
              : BILightGrey,
          backgroundColor: "rgba(0,0,0,0.3)"
        }}>
        <CloseIcon style={{ fontSize: "16px" }} />
      </IconButton>
    </div>
  ));
};

const ImageMemoComponent = memo(ImageList);

